import React from 'react';
import { Form, Field } from 'react-final-form';
import { fallbackFunc, getMessage as t } from '../../../utils/utils';
import {
  checkEmail,
  checkPassword,
  checkPhoneNumberFull,
  checkText
} from '../../../helpers';
import { connect } from 'react-redux';
import { brandIdSelector, messagesSelector } from '../../../helpers/selectors';
import { PurePhoneNumberField } from '../../account/fields/phoneNumber';
import { PureNewTextField } from '../../forms/newFields/text';
import classnames from 'classnames';
import { PurePasswordField } from '../../forms/newFields/password';

const validate = (v, p) => {
  const errors = {};
  const textFields = ['firstName', 'lastName'];

  textFields.forEach((name) => {
    errors[name] = checkText(v[name], p.m);
  });

  errors.login = checkEmail(v.login, p.m);
  errors.password = checkPassword(v.password, p.m);
  errors.phoneNumber = checkPhoneNumberFull(v.phoneNumber, p.m);

  return errors;
};

function addLabels(m, id) {
  const text = t(m, id);

  return {
    label: text,
    placeholder: text
  };
}

/**
 * @param {object} p
 * @param {Function} [p.onSubmit]
 * @param {object} [p.m] - i18n messages
 * @param {string} [p.id] - form id for external submit buttons
 */
function CreationCredentialsForm(p) {
  return (
    <Form onSubmit={p.onSubmit || fallbackFunc} validate={(v) => validate(v, p)}>
      {({ handleSubmit }) => (
        <form
          id={p.id}
          className={classnames('account-credentials-form', 'scope-section')}
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="scope-section-fields">
            <Field
              name="firstName"
              component={PureNewTextField}
              {...addLabels(p.m, 'generic.first.name')}
            />
            <Field
              name="lastName"
              component={PureNewTextField}
              {...addLabels(p.m, 'generic.last.name')}
            />
            <Field
              name="phoneNumber"
              component={PurePhoneNumberField}
              label={t(p.m, 'generic.mobile.phone')}
              mandatory
            />
            <Field
              name="login"
              component={PureNewTextField}
              autoComplete="email"
              {...addLabels(p.m, 'generic.email')}
            />
            <Field
              name="password"
              component={PurePasswordField}
              autoComplete="new-password"
              {...addLabels(p.m, 'label.password')}
            />
          </div>
        </form>
      )}
    </Form>
  );
}

function mapStateToProps(state) {
  return {
    m: messagesSelector(state),
    brandId: brandIdSelector(state)
  };
}

CreationCredentialsForm = connect(mapStateToProps)(CreationCredentialsForm);


export default CreationCredentialsForm;
